import React, { FunctionComponent } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled from 'styled-components/native'

import { Image } from '../image/Image'
import providerMatching from './../../assets/provider-matching.png'

const ProviderMatchingIllustrationPNG = styled(Image)({
  width: 202,
  height: 202,
})

export const ProviderMatchingIllustration: FunctionComponent = () => {
  return <ProviderMatchingIllustrationPNG source={providerMatching as ImageSourcePropType} />
}
